module.exports = __webpack_public_path__ + "assets/img/home.7ef9c079.png";